import { useQuery } from '@tanstack/react-query';
import { fetchProducts } from '../services/api';

/**
 * React Query hook for fetching products
 * Handles caching, loading states, and error handling
 *
 * @param {Object} filters - Current filter state
 * @returns {Object} Query result with data, isLoading, error, etc.
 */
export function useProducts(filters) {
    return useQuery({
        queryKey: ['products', filters],
        queryFn: () => fetchProducts(filters),
        keepPreviousData: true, // Show previous data while loading new page
        staleTime: 30000, // Cache for 30 seconds
        retry: 1, // Only retry once on error
    });
}
